import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import ReactPhoneInput from 'react-country-phone-input';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #f2f2f2;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  width: 360px;
  flex-direction: column;
  /* text-align: center; */
  padding: 30px;
  border-radius: 3px;
  background: ${(props) => props.theme.color.bg.primary};
  select {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid ${(props) => props.theme.color.text.tertiary};
    background: ${(props) => props.theme.color.bg.primary};
    box-shadow: 0px 0px 0px 0px #cbdafc;
    height: 48px;
    width: 100%;
    font-size: 16px;
    font-family: Montserrat;
    color: #999999;
    &::placeholder {
      color: #999999;
    }
    &:focus {
      outline: none;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
`;

// export const LogoImg = styled.img`
//   width: 120px;
//   height: auto;
// `;

export const ImageContainer = styled.div`
  img {
    width: 180px;
    height: auto;
  }
`;

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h4 {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.title.size.h4};
    font-weight: ${(props) => props.theme.font.title.weight.semi};
    line-height: ${(props) => props.theme.font.title.lineHeight.h4};
    color: ${(props) => props.theme.color.text.primary};
  }

  span {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: ${(props) => props.theme.color.text.primary};
  }
`;

export const Title = styled.h1`
  font-family: ${(props) => props.theme.font.title.family};
  font-size: ${(props) => props.theme.font.title.size.h3};
  font-weight: ${(props) => props.theme.font.title.weight.bold};
  line-height: ${(props) => props.theme.font.title.lineHeight.h3};
  color: ${(props) => props.theme.color.text.primary};
`;

export const Body = styled.div`
  span {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: ${(props) => props.theme.color.text.disabled};

    b {
      cursor: pointer;
      text-decoration: underline;
      font-weight: ${(props) => props.theme.font.body.weight.bold};
      color: ${(props) => props.theme.color.text.secondary};
    }
  }
`;

export const SocialSignUpContainer = styled.div``;

export const SocialOrContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 12px 0;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.small};
  color: ${(props) => props.theme.color.text.disabled};
`;

export const Footer = styled.div`
  width: 100%;
  margin-top: 15px;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-top: 1px solid #e6e6e6; */
  span {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: ${(props) => props.theme.color.text.disabled};
  }
`;

export const Link = styled(RouterLink)`
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  font-weight: ${(props) => props.theme.font.body.weight.bold};
  line-height: ${(props) => props.theme.font.body.lineHeight.regular};
  color: ${(props) => props.theme.color.text.secondary};
`;

export const Button = styled.button`
  width: 100%;
  margin-top: 20px;
  height: 38px;
  background-color: ${(props) => props.theme.color.ui.primary};
  color: ${(props) => props.theme.color.text.inverse};
  border-radius: 3px;
  border: none;
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-style: normal;
  font-weight: 700;
  cursor: pointer;
  &:hover {
    opacity: 0.95;
  }
`;

export const SignOutButton = styled(Button)`
  margin-top: 0;
  background-color: ${(props) => props.theme.color.bg.primary};
  color: ${(props) => props.theme.color.text.danger};
  border-width: 1px;
  border-style: solid;
  border-color: ${(props) => props.theme.color.ui.shade2};
`;

export const SliderToggle = styled.label`
  position: relative;
  display: inline-block;
  width: 32px;
  height: 16px;
  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: ${(props) => props.theme.color.bg.primary};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border: 1px solid #999999;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 12px;
    width: 12px;
    left: 1px;
    bottom: 1px;
    background-color: ${(props) => props.theme.color.ui.primary};
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: ${(props) => props.theme.color.ui.primary};
    border: 1px solid ${(props) => props.theme.color.ui.primary};
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #f79422;
  }

  input:checked + .slider:before {
    background-color: ${(props) => props.theme.color.bg.primary};
    -webkit-transform: translateX(16px);
    -ms-transform: translateX(16px);
    transform: translateX(16px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`;

export const SliderLabel = styled.span`
  font-family: Montserrat;
`;

export const CheckBoxContainer = styled.div`
  .form-check-input {
    border: 1px solid #999999;
    box-shadow: 0 0 1px #f79422;
    /* background-color: ${(props) => props.theme.color.bg.primary};
    border: 1px solid ${(props) => props.theme.color.ui.primary}; */
    &:checked {
      background-color: ${(props) => props.theme.color.ui.primary};
      border: 1px solid ${(props) => props.theme.color.ui.primary};
    }
  }
  .form-check-label {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    color: ${(props) => props.theme.color.text.primary};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
  }
`;

export const WarnIcon = styled(BsFillInfoCircleFill)`
  width: 20px;
  height: 14px;
`;

export const PhoneInput = styled(ReactPhoneInput)`
  border: none;
`;
